@if (!qrCodeError && qrOptions) {
  <div class="flex justify-center items-center" [id]="id">
    <div class="relative inline-flex justify-center items-center">
      <qrcode
        #qrcodeElement
        [qrdata]="qrData"
        [width]="options.width"
        [cssClass]="options.cssClass"
        [colorDark]="options.colorDark"
        [allowEmptyString]="options.allowEmptyString"
        [colorLight]="options.colorLight"
        [elementType]="options.elementType"
        [errorCorrectionLevel]="options.errorCorrectionLevel"
        [imageSrc]="options.imageSrc"
        [imageHeight]="options.imageHeight"
        [imageWidth]="options.imageWidth"
        [margin]="options.margin"
        [scale]="options.scale"
        [title]="options.title"
        [ariaLabel]="options.ariaLabel"
        [alt]="options.alt"
        (click)="clickOutput.emit()"
      ></qrcode>
      <svg
        class="absolute"
        [style.width.%]="25"
        [style.height.%]="25"
        [style.background-color]="options.colorLight"
        [style.padding]="options.margin"
        style="border-radius: 12%"
        viewBox="0 0 375 332"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M374.851 0.89209L258.492 1.69272L232.114 119.918L197.392 1.40778L62.2746 2.1626C62.2746 2.1626 72.4649 19.524 70.9553 50.0952C69.4456 80.6663 0 331.274 0 331.274H114.736L149.082 181.438L193.24 330.897H290.237L374.851 0.89209Z"
          fill="black"
        />
      </svg>
    </div>
  </div>
} @else {
  <div class="flex justify-center items-center" [id]="id">
    <div class="flex flex-wrap content-center border-2 border-gray-300 rounded-lg p-1 md:p-2 min-w-[100px]">
      <label class="block w-full text-sm text-center"> {{ errorLabel | translate }} </label>
      <button class="w-full flex justify-center" (click)="reloadQRCode()">
        <i class="ph ph-arrow-clockwise"></i>
      </button>
    </div>
  </div>
}
